import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { Model } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast } from "@/utils/toast";

export const useEditCustomModel = (authToken: string) => {
  const { workspaceId } = useParams();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (model: Model) => {
      const response = await fetch(
        ENDPOINTS.edit_custom_model(String(workspaceId), String(model.id)),
        {
          method: "PUT",
          body: JSON.stringify(model),
          headers: jsonAuthHeaders(authToken),
        },
      );
      return handleResponse(response);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["models", workspaceId],
      });
    },
    onError: (error: string) => {
      displayErrorToast(error);
    },
  });
};
